export class CoreExplorerLayers {
    public static ProjectKey = 'lyr_exp_project';
    public static ActivityKey = 'lyr_exp_activity';
    public static FocalKey = 'lyr_exp_focal';
    public static PrioLandKey = 'lyr_prio_land';
    public static WatershedKey = 'lyr_top_500';
    public static NonCore = 'lyr_non_core';
}